import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GeoJSON } from 'react-leaflet';

import { storage } from '../../../config';
import { getAreaImages } from '../../../utils/attachmentUtils';

import AreasList from '../../List/Areas/AreasList';
import StatesList from '../../List/Areas/StatesList';
import CountiesList from '../../List/Areas/CountiesList';
import CommunitiesList from '../../List/Areas/CommunitiesList';
import RegionsList from '../../List/Areas/RegionsList';
import AreaInformationContainer from '../AreaInformationContainer/AreaInformationContainer';
import MapWrapper from '../../Map/MapWrapper';
import AreasLayer from '../../Map/Layers/Areas';
import MapToolbarWrapper from '../../MapToolbar/MapToolbarWrapper';
import AreaReportsModal from '../../AreaReportsModal/AreaReportsModal';
import SlideshowModal from '../../Modal/SlideshowModal/SlideshowModal';
import withSize from '../../WithSize/WithSize';
// import { humanizeNumber } from '../../../utils/format';

import './Areas.css';

export class AreasComponent extends Component {
  componentWillMount() {
    const {
      areaAll,
      fetched,
      getAreas,
      layer,
      organizationId,
      getAreasAll,
      getBoundaryPolygon,
    } = this.props;
    if (!fetched || Object.keys(areaAll).length === 0) {
      getAreas(layer, organizationId);
      getAreasAll(organizationId).then(areas => {
        let boundary = areas.states.length > 2 ? 'states' : 'counties';

        if (!areas.counties.length && areas.states.length > 0) {
          boundary = 'states';
        } else if (areas.communities.length && !areas.counties.length) {
          boundary = 'communities';
        }
        getBoundaryPolygon(boundary, organizationId);
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      areaAll,
      fetched,
      getAreas,
      layer,
      organizationId,
      active,
      getAreaPolygon,
      match: { params: { id } },
      addActive,
    } = nextProps;

    if ((layer !== this.props.layer && !fetched) || Object.keys(areaAll).length === 0) {
      getAreas(layer, organizationId);
    } else if (!active && fetched && id) {
      const area = nextProps[layer].find(a => a._id === id);
      if (area) {
        addActive(layer, area, true);
      }
    }

    if (layer !== 'communities' && active && !active.polygon) {
      getAreaPolygon(layer, active);
    }
  }

  render() {
    const {
      active,
      activeColor,
      addActive,
      addFilter,
      addLayer,
      filters,
      sort,
      loading,
      layer,
      layers,
      overview,
      openModal,
      states,
      counties,
      communities,
      regions,
      organizationId,
      match: { params: { subTab } },
      routeToSubTab,
      showShareModal,
      showSlideshow,
      showDownloadModal,
      showSpecialDownloadModal,
      showModal,
      areasToShow,
      detailInfoToShow,
      isMobile,
      countiesLength,
      communitiesLength,
      regionsLength,
      statesLength,
      organizationContact,
      viewer,
      areaAll,
      // measure,
    } = this.props;

    let areasListStyle = {};

    if (active && isMobile) {
      areasListStyle = { zIndex: 1 };
    } else if (isMobile) {
      areasListStyle = { zIndex: 5 };
    }

    const images = active ? getAreaImages(overview || {}) : [];
    const areaAllLength = {
      Counties: countiesLength,
      Communities: communitiesLength,
      Regions: regionsLength,
      States: statesLength,
    };

    let shapes = states.length > 2 ? states : counties;

    if (!counties.length && states.length > 0) {
      shapes = states;
    } else if (communities.length && !counties.length) {
      shapes = communities;
    }

    return (
      <div className="content-wrapper areas">
        <AreaReportsModal
          area={overview.details}
          type={layer}
        />
        <AreasList
          handleClick={addLayer}
          activeMenu={layer}
          areasToShow={areasToShow}
          style={areasListStyle}
          areaAllLength={areaAllLength}
        >
          {layer === 'states' && <StatesList states={states} handleClick={addActive} />}
          {layer === 'counties' && <CountiesList counties={counties} handleClick={addActive} />}
          {layer === 'communities' && <CommunitiesList communities={communities} handleClick={addActive} /> }
          {layer === 'regions' && <RegionsList regions={regions} handleClick={addActive} /> }
          {loading && (
            <div style={{ padding: 20 }}>
              <img
                alt="loading gif"
                src={`${storage.distPath}/loading.gif`}
              />
            </div>
          )}
        </AreasList>
        <MapWrapper
          layers={layers}
          zoom={7}
          type="areas"
          polygons={(shapes || []).filter(area => !!area.polygon).map((area, index) => (
            <GeoJSON
              data={area.polygon}
              key={`${layer}${index}`}
              style={{
                color: activeColor,
                weight: 0,
                fillOpacity: 0,
              }}
            />),
          )}
          ignoreMap={isMobile}
          mapChildren={[(
            <div key="areasLayer">
              {
                Object.keys(areaAll).length > 0 &&
                <AreasLayer
                  activeColor={activeColor}
                  layer={layer}
                  areas={areaAll}
                  handleClick={addActive}
                />
              }
            </div>
          )]}
        >
          {active &&
            <AreaInformationContainer
              addFilter={addFilter}
              filters={filters}
              sort={sort}
              area={active}
              handleClick={addActive}
              overview={overview}
              handleModalClick={openModal}
              organizationId={organizationId}
              layer={layer}
              subTab={subTab}
              routeToSubTab={routeToSubTab}
              showShareModal={showShareModal}
              showDownloadModal={showDownloadModal}
              showSpecialDownloadModal={showSpecialDownloadModal}
              detailInfoToShow={detailInfoToShow}
              showSlideshow={showSlideshow}
              showModal={showModal}
              organizationContact={organizationContact}
              viewer={viewer}
            />
          }
          {active &&
            <SlideshowModal
              id={active._id}
              property={active}
              images={images}
              modalTitle="Area Images"
            />
          }
          <MapToolbarWrapper type="areas" />
        </MapWrapper>
      </div>
    );
  }
}

AreasComponent.propTypes = {
  active: PropTypes.object,
  activeColor: PropTypes.string,
  addActive: PropTypes.func.isRequired,
  addLayer: PropTypes.func.isRequired,
  addFilter: PropTypes.func,
  filters: PropTypes.shape({
    buildings: PropTypes.object,
    sites: PropTypes.object,
  }),
  sort: PropTypes.shape({
    buildings: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    sites: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  }),
  getAreas: PropTypes.func,
  getAreasAll: PropTypes.func,
  getAreaPolygon: PropTypes.func.isRequired,
  getBoundaryPolygon: PropTypes.func,
  routeToSubTab: PropTypes.func.isRequired,
  showShareModal: PropTypes.func.isRequired,
  showSlideshow: PropTypes.func.isRequired,
  showDownloadModal: PropTypes.func.isRequired,
  showSpecialDownloadModal: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  fetched: PropTypes.bool,
  loading: PropTypes.bool,
  layer: PropTypes.string.isRequired,
  layers: PropTypes.object,
  countiesLength: PropTypes.arrayOf(PropTypes.object),
  regionsLength: PropTypes.arrayOf(PropTypes.object),
  communitiesLength: PropTypes.arrayOf(PropTypes.object),
  statesLength: PropTypes.arrayOf(PropTypes.object),
  states: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      geo: PropTypes.object,
    }),
  ).isRequired,
  counties: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      geo: PropTypes.object,
    }),
  ).isRequired,
  communities: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      geo: PropTypes.object,
    }),
  ).isRequired,
  regions: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      geo: PropTypes.object,
    }),
  ).isRequired,
  overview: PropTypes.object,
  openModal: PropTypes.func,
  organizationId: PropTypes.string,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      subTab: PropTypes.string,
    }),
  }),
  areasToShow: PropTypes.arrayOf(PropTypes.string),
  detailInfoToShow: PropTypes.arrayOf(PropTypes.string),
  isMobile: PropTypes.bool.isRequired,
  organizationContact: PropTypes.object,
  viewer: PropTypes.object.isRequired,
  // measure: PropTypes.bool,
  areaAll: PropTypes.object,
};

export default withSize(AreasComponent);



// WEBPACK FOOTER //
// ./src/components/Areas/AreasWrapper/Areas.js